/** @jsxImportSource @emotion/react */
import React from 'react';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';

import Image from 'Components/Image';

import Selectors from 'Redux/Selectors';

import {
    StyleImageContainer,
    ProductImg,
    Variation,
    Remarks,
    RowFlexCenter,
    ProductListItemStyle,
    MobileListStyle,
    MobileListStyleBold,
    ProductListItemQuantityStyle,
    cartProductListTable,
} from 'Containers/User/Styles/ComponentStyles';
import Utils from 'Lib/Utils';

function ProductsListComponent({ product }) {
    const { name, selectedVariant, quantity, imageUrl, imageFileNames, remarks, customAttributes, currency } = product;

    const goldPrice = useSelector(Selectors.getHomeGoldPrice);

    const variantPrice = Utils.Jemisys.getItemVariantPrice(product, selectedVariant, goldPrice);
    const totalCost = variantPrice * quantity;

    const salesType = Utils.Product.getSalesType(customAttributes);
    const variantName = Utils.Product.getItemVariantSizeLengthString(selectedVariant);

    const imageSrc = imageFileNames?.length ? imageFileNames[0] : imageUrl[0];

    const renderVariation = () => {
        if (salesType === 'JEWELERY') return false;

        return <div css={Variation}>{variantName}</div>;
    };

    return (
        <>
            <Row css={cartProductListTable} className='py-5 d-none d-sm-flex'>
                <Col xs='10' xl='8'>
                    <Row>
                        <Col style={{ maxWidth: 'fit-content' }}>
                            <Image
                                css={ProductImg}
                                url={imageSrc}
                                alt='Product Img'
                                style={{ display: 'flex' }}
                            />
                        </Col>
                        <Col>
                            <div
                                css={ProductListItemStyle}
                                style={{ fontWeight: '700' }}
                            >
                                {name}
                            </div>
                            <div css={ProductListItemStyle}>
                                {`${currency} ${Utils.Formatter.currencyFormatter(totalCost)}`}
                            </div>
                            <div css={ProductListItemQuantityStyle}>
                                <p>Quantity:</p>
                                {quantity}
                            </div>
                            {renderVariation()}
                            {remarks && (<div css={Remarks}>{`Remarks : ${remarks}`}</div>)}
                        </Col>
                    </Row>
                </Col>

                {/* <Col xs='2' css={RowFlexCenter}>
                    <div css={ProductListItemStyle}>
                        {Utils.Formatter.currencyFormatter(labourCost)}
                    </div>
                </Col> */}
            </Row>
            <Row className='mt-5 mb-5 d-flex d-sm-none'>
                <Col xs='4'>
                    <Image
                        css={ProductImg}
                        url={imageSrc}
                        alt='Product Img'
                    />
                </Col>
                <Col xs='8'>
                    <div
                        css={ProductListItemStyle}
                        style={{ fontWeight: '700' }}
                    >
                        {name}
                    </div>
                    {renderVariation()}
                    <div css={MobileListStyle}>
                        <span css={MobileListStyleBold}>Quantity: </span>
                        {quantity}
                    </div>
                    <div css={MobileListStyle}>
                        <span css={MobileListStyleBold}>Price: </span>
                        {Utils.Formatter.currencyFormatter(variantPrice)}
                    </div>
                    {/* <div css={MobileListStyle}>
                        <span css={MobileListStyleBold}>Labour: </span>
                        {Utils.Formatter.currencyFormatter(labourCost)}
                    </div> */}
                    <div css={MobileListStyle}>
                        <span css={MobileListStyleBold}>Total: </span>
                        {Utils.Formatter.currencyFormatter(totalCost)}
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default ProductsListComponent;
